import { render } from "./file-shared.vue?vue&type=template&id=041f2a44"
import script from "./file-shared.vue?vue&type=script&lang=js"
export * from "./file-shared.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__